import { Component } from 'react';
import DataTable from '../../../../../components/Datatable';
import { getSortKeys, setAdditionalStyles } from '../../../../../helpers/table';
import { COLUMNS } from './keys';
import { withTranslation } from 'react-i18next';
import Loading from '../../../../../components/Loading';

class Entities extends Component {
    constructor() {
        super();
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) =>
            item?.brand_name?.toLowerCase()?.includes(search.toLowerCase()),
        );
    }

    render() {
        const { t } = this.props;
        if (this.props.loading) {
            return <Loading />;
        }

        return (
            <div className="card">
                <DataTable
                    nodes={this.props.items}
                    sortFns={getSortKeys(COLUMNS(t))}
                    COLUMNS={COLUMNS(t)}
                    fileName={t('ai_tracking.prompt_history.entities.header')}
                    header={t('ai_tracking.prompt_history.entities.header')}
                    customEmptyMessage={t('global.no_data')}
                    searchFunction={this.searchFunction}
                    additionalStyles={setAdditionalStyles(COLUMNS(t))}
                />
            </div>
        );
    }
}

export default withTranslation()(Entities);
